var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7996 6H13.1996C11.2114 6 9.59961 8.01472 9.59961 10.5V37.5C9.59961 39.9853 11.2114 42 13.1996 42H34.7996C36.7878 42 38.3996 39.9853 38.3996 37.5V10.5C38.3996 8.01472 36.7878 6 34.7996 6Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 15.5,
    r: 2,
    fill: "#5F738C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5L33 23.5",
    stroke: "#5F738C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.5H33",
    stroke: "#5F738C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33.5H33",
    stroke: "#5F738C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomType);
export default __webpack_public_path__ + "static/media/custom_type.52af74634f950c059ec00a720896c3bc.svg";
export { ForwardRef as ReactComponent };